import { render, staticRenderFns } from "./CustomerUpdateModal.vue?vue&type=template&id=455b0a5c&scoped=true"
import script from "./CustomerUpdateModal.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b0a5c",
  null
  
)

export default component.exports